




















import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    "price-lists-table-store": () =>
      import(
        "@/components/app/admin/catalogue/priceLists/priceListsTableStore.vue"
      )
  }
})
export default class PriceLists extends Vue {
  public $refs!: {
    priceListTable: HTMLFormElement;
  };

  public get i18n() {
    return {
      createProduct: this.$t("_action.add_object", {
        object: this.$t("_.price_list")
          .toString()
          .toLowerCase()
      }),
      title: this.$t("_.price_lists")
    };
  }

  public openCreatePricelistModal() {
    if (this.$userCan(`create_pricelist`)) {
      this.$refs.priceListTable.openAddEditPricelistModal();
    }
  }
}
